/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const AnimalPrintIconOutline = createIcon({
  displayName: 'AnimalPrintIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M9.95393,20.04607l.339-.339A2.41421,2.41421,0,0,1,12,19h0a2.41421,2.41421,0,0,1,1.70711.70711l.339.339A3.25693,3.25693,0,0,0,16.34907,21h.394A3.25694,3.25694,0,0,0,20,17.74306h0a3.257,3.257,0,0,0-1.45031-2.70994h0a7.9781,7.9781,0,0,1-2.48174-2.64561L15.148,10.796A3.59505,3.59505,0,0,0,12.03549,9h0a3.59506,3.59506,0,0,0-3.08274,1.74541L7.923,12.46167a7.978,7.978,0,0,1-2.41568,2.53345l-.057.038A3.257,3.257,0,0,0,4,17.74306H4A3.25694,3.25694,0,0,0,7.25694,21h.394A3.25693,3.25693,0,0,0,9.95393,20.04607Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle cx="4.5" cy="9.5" r="1.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <circle cx="19.5" cy="9.5" r="1.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <circle
        cx="8.78571"
        cy="4.5"
        r="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="15.21429"
        cy="4.5"
        r="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const AnimalPrintIconTwoTone = createIcon({
  displayName: 'AnimalPrintIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="path"
        d="M9.95393,20.04607l.339-.339A2.41421,2.41421,0,0,1,12,19h0a2.41421,2.41421,0,0,1,1.70711.70711l.339.339A3.25693,3.25693,0,0,0,16.34907,21h.394A3.25694,3.25694,0,0,0,20,17.74306h0a3.257,3.257,0,0,0-1.45031-2.70994h0a7.9781,7.9781,0,0,1-2.48174-2.64561L15.148,10.796A3.59505,3.59505,0,0,0,12.03549,9h0a3.59506,3.59506,0,0,0-3.08274,1.74541L7.923,12.46167a7.978,7.978,0,0,1-2.41568,2.53345l-.057.038A3.257,3.257,0,0,0,4,17.74306H4A3.25694,3.25694,0,0,0,7.25694,21h.394A3.25693,3.25693,0,0,0,9.95393,20.04607Z"
        fill="twoToneFillColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="4.5"
        cy="9.5"
        r="1.5"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="19.5"
        cy="9.5"
        r="1.5"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="8.78571"
        cy="4.5"
        r="1.5"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="15.21429"
        cy="4.5"
        r="1.5"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const AnimalPrint: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={AnimalPrintIconTwoTone} {...props} />
    default:
      return <CustomIcon as={AnimalPrintIconOutline} {...props} />
  }
}

export default memo(AnimalPrint)
